import Vue from 'vue';

const success = (resolve) => {
  resolve();
};

const failed = (error, reject) => {
  reject(error);
};

export default (campaignId, id) => (
  new Promise((resolve, reject) => {
    Vue.$http
      .delete(`news_campaigns/${campaignId}/clients/${id}`)
      .then(() => {
        success(resolve);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/clientCampaign/destroy.js